<template>
  <div>
    <a class="text-blueGray-500 block" href="#pablo" ref="btnDropdownRef" v-on:click="toggleDropdown($event)">
      <div class="items-center flex">
        <span class="w-12 h-12 text-sm text-white bg-blueGray-200 inline-flex items-center justify-center rounded-full">
          <img alt="..." class="w-full rounded-full align-middle border-none shadow-lg" :src="image" />
        </span>
      </div>
    </a>
    <div ref="popoverDropdownRef"
      class="bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48" v-bind:class="{
        hidden: !dropdownPopoverShow,
        block: dropdownPopoverShow,
      }">
      <router-link to="/perfil" @click="closeDropdown()"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700">
        {{ $t('button.profile') }}
      </router-link>
      <a href="javascript:void(0);" @click="logout()"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700">
        {{ $t('button.logout') }}
      </a>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import { createPopper } from "@popperjs/core";
import store from "@/store";
import image from "@/assets/img/avatar.png";

export default {
  data() {
    return {
      dropdownPopoverShow: false,
      image: image,
    };
  },
  methods: {
    toggleDropdown: function (event) {
      event.preventDefault();
      if (this.dropdownPopoverShow) {
        this.dropdownPopoverShow = false;
      } else {
        this.dropdownPopoverShow = true;
        createPopper(this.$refs.btnDropdownRef, this.$refs.popoverDropdownRef, {
          placement: "bottom-start",
        });
      }
    },
    closeDropdown: function () {
      this.dropdownPopoverShow = false;
    },

    logout() {
      const toast = useToast();
      this.closeDropdown();

      try {
        store.dispatch("auth/logout").then(
          () => {
            this.$router.push("/auth/login");
          },
          (error) => {
            let errors =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
            toast.error(errors);
            console.error(errors);
          }
        );
      } catch (error) {
        toast.error(error);
        console.error(error);
      }
    }
  },
};
</script>
